<script lang="ts">
export default {
  name: 'KkTabList',
}
</script>

<script setup lang="ts">
type MenuList = {
  [key: string]: string
}
type Props = {
  menuList: MenuList
  selectedTabKey: string
  iconKeys?: (keyof MenuList)[]
}

interface Emits {
  (e: 'click-menu', key: keyof MenuList): void
}

const props = withDefaults(defineProps<Props>(), {
  iconKeys: () => [],
})
const emit = defineEmits<Emits>()
</script>
<template>
  <div class="p-box__header">
    <ul class="c-links">
      <li
        v-for="(menu, key) in props.menuList"
        :key="key"
        class="c-links__item"
      >
        <div class="buttonWrapper">
          <button
            :class="{ active: key === props.selectedTabKey }"
            @click="emit('click-menu', key)"
          >
            {{ menu }}
          </button>
          <slot v-if="props.iconKeys.length && props.iconKeys.includes(key)" :key="key" name="icon" />
        </div>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.c-links {
  flex-wrap: wrap;
  width: 100%;

  button {
    color: #E9446A;

    &.active {
      color: #3A3B3F;
    }

    &:hover {
      text-decoration: underline;
    }
  }
}
.buttonWrapper {
  display: flex;
  align-items: center;
}
</style>
